// helper for API requests
import axios from "axios";

//for accessing the url string
import qs from "query-string";

//weaviate javascript client library
import weaviate from "weaviate-client";

import { getOidcInfoURL, getOidcTokenURL } from "./oidcFunctions"

//handles the change in the browser's theme preference.
//it has a listener so it reads the theme when the console is first loaded
//and also listens for live changes in the theme. Light or Dark
export const handleBrowserTheme = (setState, state) => {
  if (matchMedia && matchMedia("(prefers-color-scheme: dark)").matches) {
    setState({ ...state, theme: "dark" });
  }
};

//gets header object based on user authentication
export const headerObj = () => {
  const token = JSON.parse(localStorage.getItem("access_token"));
  const isWeaviateAuthenticated = JSON.parse(
    localStorage.getItem("isWeaviateAuthenticated")
  );

  if (isWeaviateAuthenticated === true && token !== "") {
    return {
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`,
      origin: window.origin,
    };
  } else {
    return {
      "Content-Type": "application/json",
      origin: window.origin,
    };
  }
};

// This function decides the state of weaviate to display to the user
//located in the top bar. It's either connected or disconnected
export const weaviateStateGetter = (state, setIsWeaviateConnected) => {
  // Access the url params if there is any
  const hashObj = qs.parse(window.location.hash);
  const tokenURL = getOIDCTokenURL()
  var azureHybrid = tokenURL.startsWith('https://login.microsoftonline.com')
  if (azureHybrid && hashObj.id_token) {
    localStorage.setItem("access_token", JSON.stringify(hashObj.id_token));
    localStorage.setItem("refresh_token", JSON.stringify(hashObj.id_token));
    // localStorage.setItem("access_token_expire",
    //   JSON.stringify(Math.floor(Date.now() / 1000) + res.data.expires_in)
    // );
  }
  const uri = () => {
    if (state.connectToWeaviateURI) {
      return state.connectToWeaviateURI;
    } else if (
      state.connectToWeaviateURI === "" &&
      hashObj &&
      hashObj.weaviate_uri
    ) {
      return hashObj.weaviate_uri;
    }
  };

  //runs the weaviate checker function which makes a request
  //and based on the response, it decides if weaviate is working or not
  const checker = () => {
    const response = weaviateChecker(uri(), setIsWeaviateConnected);

    if (response === undefined || response) {
      setIsWeaviateConnected(true);
    } else {
      setIsWeaviateConnected(false);
    }
  };

  if (
    state.connectToWeaviateURI === "" &&
    hashObj &&
    hashObj.weaviate_uri === undefined
  ) {
    return;
  } else {
    checker();
  }
};

//every so often, this function will run and exchange the refresh keycloak
//token for the new access_token. It does this so we don't need to log out the user
//very often
export const checkTokens = async () => {
  const isWeaviateAuthenticatedRef =
    localStorage.getItem("isWeaviateAuthenticated") || null;

  if (JSON.parse(isWeaviateAuthenticatedRef)) {
    const clientId = localStorage.getItem("clientId");
    const refreshToken = localStorage.getItem("refresh_token");
    const tokenURL = getOIDCTokenURL()
    // refresh the current session
    axios({
      method: "post",
      url: tokenURL,
      data: qs.stringify({
        grant_type: "refresh_token",
        client_id: JSON.parse(clientId),
        refresh_token: JSON.parse(refreshToken),
      }),
      headers: {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      },
    })
      .then((res) => {
        localStorage.setItem(
          "access_token",
          JSON.stringify(res.data.access_token)
        );
        localStorage.setItem(
          "refresh_token",
          JSON.stringify(res.data.refresh_token)
        );
        localStorage.setItem(
          "access_token_expire",
          JSON.stringify(Math.floor(Date.now() / 1000) + res.data.expires_in)
        );
      })
      .catch((err) => {
        console.log(err.response.data.description);
        console.log(err.request);
        console.log(err.message);
      });
  } else {
    return;
  }
};

//it gets the user metrics from Enterprise collector service
export const getUserMetrics = async (token, setState, state) => {
  setState({
    ...state,
    currentModule: window.location.pathname.split("/")[2],
    connectToWeaviateURI: JSON.parse(
      localStorage.getItem("connectToWeaviateURI")
    ),
  });
};

//this function checks for the self hosted weaviate version. Auth and no-auth
const checkSelfHostedWeaviateVersion = (state, history, token) => {
  const authenticated = JSON.parse(
    localStorage.getItem("isWeaviateAuthenticated")
  );

  if (authenticated) {
    const client = weaviate.client({
      scheme: getWeaviateScheme(state.connectToWeaviateURI) || "http",
      host: getWeaviateHost(state.connectToWeaviateURI) || "localhost:8080",
      headers: {
        authorization: `Bearer ${token}`,
      },
    });

    client.misc
      .metaGetter()
      .do()
      .then((res) => {
        localStorage.setItem(
          "selfHostedWeaviateVersion",
          JSON.stringify(res.version)
        );
        if (res.version < "1.0.0") {
          history.push("/update-weaviate-version");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  } else {
    const client = weaviate.client({
      scheme: getWeaviateScheme(state.connectToWeaviateURI) || "http",
      host: getWeaviateHost(state.connectToWeaviateURI) || "localhost:8080",
    });

    client.misc
      .metaGetter()
      .do()
      .then((res) => {
        localStorage.setItem(
          "selfHostedWeaviateVersion",
          JSON.stringify(res.version)
        );
        if (res.version < "1.0.0") {
          history.push("/update-weaviate-version");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
};

//this function runs when the console if first loaded after log in
//and if there is authentication involved through keycloak. I does not run
//for self hosted weaviate without authentication
//it basically gets the access_token and the refresh_token from keycloak
export const getUserToken = async (urlCode, state, history, setState) => {
  const isWeaviateAuthenticatedRef = localStorage.getItem(
    "isWeaviateAuthenticated"
  );
  const oidcUri = localStorage.getItem("oidcUri");
  const clientId = localStorage.getItem("clientId");
  const tokenURL = getOIDCTokenURL()
  const userInfoURL = getOIDCInfoURL()

  const azureHybrid = tokenURL.startsWith('https://login.microsoftonline.com')
  if (JSON.parse(isWeaviateAuthenticatedRef) && !azureHybrid) {
    axios({
      method: "post",
      url: tokenURL,
      data: qs.stringify({
        grant_type: "authorization_code",
        client_id: JSON.parse(clientId),
        code: urlCode,
        redirect_uri: `${window.origin}/console/${state.currentModule}`,
      }),
      headers: {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      },
    })
      .then(async (res) => {
        localStorage.setItem(
          "access_token",
          JSON.stringify(res.data.access_token)
        );
        localStorage.setItem(
          "refresh_token",
          JSON.stringify(res.data.refresh_token)
        );
        localStorage.setItem(
          "access_token_expire",
          JSON.stringify(Math.floor(Date.now() / 1000) + res.data.expires_in)
        );

        const token = res.data.access_token;

        getUserMetrics(token, setState, state);

        if (JSON.parse(clientId) === "wcs") {
          const userInfo = await axios({
            method: "get",
            url: userInfoURL,
            headers: {
              authorization: `Bearer ${res.data.access_token}`,
            },
          });

          localStorage.setItem(
            "wcsUserEmail",
            JSON.stringify(userInfo.data.email)
          );

          setState({ ...state, wcsUserEmail: userInfo.data.email });

          history.push(`/console/${state.currentModule}`);
        } else {
          const token = res.data.access_token;
          checkSelfHostedWeaviateVersion(state, history, token);
        }
      })
      .catch((err) => {
        console.log(err);
        history.push(`/console/${state.currentModule}`);
      });
  } else {
    checkSelfHostedWeaviateVersion(state, history);
  }
};

//these two functions is for setting up the host and scheme for
//the weaviate client set up
export const getWeaviateHost = (uri) => {
  if (uri.substring(0, 5) === "https") {
    return uri.slice(8);
  } else if (uri.substring(0, 5) === "http:") {
    return uri.slice(7);
  } else if (!uri.includes("http") && !uri.includes("https")) {
    return uri;
  } else {
    return "";
  }
};
export const getWeaviateScheme = (uri) => {
  if (uri.substring(0, 5) === "https") {
    return "https";
  } else if (uri.substring(0, 5) === "http:") {
    return "http";
  } else if (!uri.includes("http") && !uri.includes("https")) {
    return "http";
  } else {
    return "";
  }
};

//convert window.origin to secure https
export const convertToHTTPS = () => {
  const origin = window.origin;

  return origin.replace("http", "https");
};

export const convertToHTTP = () => {
  const origin = window.origin;

  return origin.replace("https", "http");
};

//handles the wcs service login
export const wcsLogin = (setState, state) => {
  if (
    window.location.protocol === "http:" &&
    !window.origin.includes("localhost") &&
    !window.location.href.includes("preview")
  ) {
    setState({
      ...state,
      isBrowserProtocolModalOpen: true,
      upgradeBrowserProtocol: true,
    });
  } else {
    setState({
      ...state,
      oidcUri: window.consoleConfig.wcsOidcUri,
      clientId: "wcs",
      currentModule: "wcs",
    });

    localStorage.setItem("isWeaviateAuthenticated", JSON.stringify(true));
    localStorage.setItem("isWeaviateSelfHosted", JSON.stringify(false));
    localStorage.setItem(
      "oidcUri",
      JSON.stringify(window.consoleConfig.wcsOidcUri)
    );
    localStorage.setItem("clientId", JSON.stringify("wcs"));
    localStorage.setItem("currentModule", JSON.stringify("wcs"));
    localStorage.setItem("isLoggedIn", JSON.stringify(true));

    window.location = `${window.consoleConfig.wcsOidcUri}protocol/openid-connect/auth?client_id=wcs&response_mode=fragment&response_type=code&redirect_uri=${window.origin}/console/wcs`;
  }
};

//handles the wcs service sign up for new users
export const wcsRegister = (setState, state) => {
  if (
    window.location.protocol === "http:" &&
    !window.origin.includes("localhost")
  ) {
    setState({
      ...state,
      isBrowserProtocolModalOpen: true,
      upgradeBrowserProtocol: true,
    });
  } else {
    setState({
      ...state,
      oidcUri: window.consoleConfig.wcsOidcUri,
      clientId: "wcs",
    });

    window.location = `${window.consoleConfig.wcsOidcUri}protocol/openid-connect/registrations?client_id=wcs&response_type=code&redirect_uri=${window.origin}/registration-login`;
  }
};

//handles the log out functionality. Takes user back to starting page
export const logOut = (setState, state, history) => {
  const isWeaviateAuthenticatedRef = localStorage.getItem(
    "isWeaviateAuthenticated"
  );
  const oidcConfiguration = JSON.parse(localStorage.getItem("oidcConfiguration"));

  setState({
    ...state,
    isLoggedIn: false,
    isWeaviateAuthenticated: null,
    isWeaviateSelfHosted: null,
    account: { accountButton: null },
    currentModule: "home",
    wcsUserEmail: "",
    clientId: "",
    isWeaviateURIDisconnected: true,
    oidcConfiguration
  });

  localStorage.setItem("refresh_token", JSON.stringify(""));
  localStorage.setItem("access_token", JSON.stringify(""));
  localStorage.setItem("isWeaviateAuthenticated", JSON.stringify(null));
  localStorage.setItem("isWeaviateSelfHosted", JSON.stringify(null));
  localStorage.setItem("isLoggedIn", JSON.stringify(false));
  localStorage.setItem("clientId", JSON.stringify(""));
  localStorage.setItem("oidcUri", JSON.stringify(""));
  localStorage.setItem("oidcConfiguration", JSON.stringify(""));
  localStorage.setItem("wcsUserEmail", JSON.stringify(""));
  localStorage.setItem("currentModule", JSON.stringify("home"));
  localStorage.setItem("isWeaviateURIDisconnected", JSON.stringify(true));

  localStorage.setItem("selfHostedOidcUri", JSON.stringify(""));

  if (!JSON.parse(isWeaviateAuthenticatedRef)) {
    history.push("/");
  } else {
    history.push("/logout");
  }
};

//checks if the weaviate instance is valid
export const weaviateChecker = (uri, setIsWeaviateConnected) => {
  const playground = "https://demo.dataset.playground.semi.technology";

  if (uri === playground) {
    return "working";
  } else {
    const client = weaviate.client({
      scheme: getWeaviateScheme(uri),
      host: getWeaviateHost(uri),
    });

    client.misc
      .liveChecker()
      .do()
      .then((res) => {
        return res;
      })
      .catch((err) => {
        setIsWeaviateConnected(false);
      });
  }
};

//handles connecting to a self hosted weaviate when clicking 'connect' in the
//start page
export const connectToSelfHostedWeaviate = (history, setState, state) => {
  // First check if the weaviate instance is a whitelisted demo dataset
  if (
    state.connectToWeaviateURI ===
    "https://demo.dataset.playground.semi.technology" ||
    state.connectToWeaviateURI ===
    "https://newsarticles.demo.data.semi.technology" ||
    state.connectToWeaviateURI ===
    "https://demo.dataset.playground.semi.technology/" ||
    state.connectToWeaviateURI ===
    "https://newsarticles.demo.data.semi.technology/" ||
    state.connectToWeaviateURI === "https://arxiv.demo.data.semi.technology/" ||
    state.connectToWeaviateURI === "https://arxiv.demo.data.semi.technology"
  ) {
    setState({
      ...state,
      connectToWeaviateShow: false,
      isLoggedIn: true,
      isWeaviateAuthenticated: false,
      isWeaviateSelfHosted: true,
      isWeaviateURIDisconnected: false,
    });

    localStorage.setItem("isWeaviateAuthenticated", JSON.stringify(false));
    localStorage.setItem("isWeaviateSelfHosted", JSON.stringify(true));
    localStorage.setItem("isLoggedIn", JSON.stringify(true));
    localStorage.setItem("oidcUri", JSON.stringify(""));
    localStorage.setItem("oidcConfiguration", JSON.stringify(""));
    localStorage.setItem("isWeaviateURIDisconnected", JSON.stringify(false));
    localStorage.setItem("clientId", JSON.stringify(""));
    localStorage.setItem("access_token", JSON.stringify(""));
    localStorage.setItem("refresh_token", JSON.stringify(""));
    localStorage.setItem(
      "connectToWeaviateURI",
      JSON.stringify(state.connectToWeaviateURI)
    );

    localStorage.setItem("selfHostedOidcUri", JSON.stringify(""));

    history.push(`/console/${state.currentModule}`);
  } else if (state.connectToWeaviateURI === "") {
    setState({
      ...state,
      isLogInSelfHostedIncorrect: true,
      isLoginLoading: false,
    });
  } else if (
    !state.connectToWeaviateURI.includes("localhost") &&
    !state.connectToWeaviateURI.includes("https") &&
    window.location.protocol === "https:" &&
    !state.keepCurrentProtocol
  ) {
    setState({
      ...state,
      isBrowserProtocolModalOpen: true,
      upgradeBrowserProtocol: false,
    });
  } else {
    const client = weaviate.client({
      scheme: getWeaviateScheme(state.connectToWeaviateURI) || "http",
      host: getWeaviateHost(state.connectToWeaviateURI) || "localhost:8080",
    });

    client.misc
      .openidConfigurationGetter()
      .do()
      .then((res) => {
        //if the response is undefined it means that there is no authentication for weaviate
        if (res === undefined) {
          if (!state.connectToWeaviateURI.includes("http")) {
            setState({
              ...state,
              connectToWeaviateShow: false,
              isLoggedIn: true,
              isWeaviateAuthenticated: false,
              isWeaviateSelfHosted: true,
              isWeaviateURIDisconnected: false,
              isLoginLoading: false,
              connectToWeaviateURI: "http://" + state.connectToWeaviateURI,
              keepCurrentProtocol: false,
            });
          } else {
            setState({
              ...state,
              connectToWeaviateShow: false,
              isLoggedIn: true,
              isWeaviateAuthenticated: false,
              isWeaviateSelfHosted: true,
              isWeaviateURIDisconnected: false,
              isLoginLoading: false,
              keepCurrentProtocol: false,
            });
          }

          localStorage.setItem(
            "isWeaviateAuthenticated",
            JSON.stringify(false)
          );
          localStorage.setItem("isWeaviateSelfHosted", JSON.stringify(true));
          localStorage.setItem("isLoggedIn", JSON.stringify(true));
          localStorage.setItem("oidcUri", JSON.stringify(""));
          localStorage.setItem("oidcConfiguration", JSON.stringify(""));
          localStorage.setItem(
            "isWeaviateURIDisconnected",
            JSON.stringify(false)
          );
          localStorage.setItem("clientId", JSON.stringify(""));
          localStorage.setItem("access_token", JSON.stringify(""));
          localStorage.setItem("refresh_token", JSON.stringify(""));

          history.push(`/console/${state.currentModule}`);
        } else if (res) {
          //if here is a response, then it means the weaviate requires authentication
          //and it redirects the user to the login page for keycloak
          axios
            .get(res.href)
            .then((response) => {
              const oidcConfiguration = {
                auth: response.data.authorization_endpoint,
                logout: response.data.end_session_endpoint,
                token: response.data.token_endpoint,
                userInfo: response.data.userinfo_endpoint,
                scopes: res.scopes,
                clientId: res.clientId
              }
              localStorage.setItem("oidcConfiguration", JSON.stringify(oidcConfiguration));
              if (!state.connectToWeaviateURI.includes("http")) {
                setState({
                  ...state,
                  isWeaviateAuthenticated: true,
                  isWeaviateSelfHosted: true,
                  connectToWeaviateShow: false,
                  oidcUri: response.data.authorization_endpoint.slice(0, -28),
                  clientId: res.clientId,
                  isWeaviateURIDisconnected: false,
                  isLoginLoading: false,
                  connectToWeaviateURI: "http://" + state.connectToWeaviateURI,
                  keepCurrentProtocol: false,
                  selfHostedOidcUri: response.data.authorization_endpoint,
                  selfHostedOidcScopes: res.scopes,
                  oidcConfiguration
                });
                localStorage.setItem(
                  "connectToWeaviateURI",
                  JSON.stringify("http://" + state.connectToWeaviateURI)
                );
              } else {
                setState({
                  ...state,
                  isWeaviateAuthenticated: true,
                  isWeaviateSelfHosted: true,
                  connectToWeaviateShow: false,
                  oidcUri: response.data.authorization_endpoint.slice(0, -28),
                  clientId: res.clientId,
                  isWeaviateURIDisconnected: false,
                  isLoginLoading: false,
                  keepCurrentProtocol: false,
                  selfHostedOidcUri: response.data.authorization_endpoint,
                  selfHostedOidcScopes: res.scopes,
                  oidcConfiguration
                });
                localStorage.setItem(
                  "connectToWeaviateURI",
                  JSON.stringify(state.connectToWeaviateURI)
                );
              }

              localStorage.setItem(
                "isWeaviateAuthenticated",
                JSON.stringify(true)
              );
              localStorage.setItem(
                "isWeaviateURIDisconnected",
                JSON.stringify(false)
              );
              localStorage.setItem(
                "isWeaviateSelfHosted",
                JSON.stringify(true)
              );
              localStorage.setItem("isLoggedIn", JSON.stringify(true));
              // OIDC
              localStorage.setItem(
                "oidcUri",
                JSON.stringify(
                  response.data.authorization_endpoint.slice(0, -28)
                )
              );
              localStorage.setItem("clientId", JSON.stringify(res.clientId));
              localStorage.setItem("selfHostedOidcUri", JSON.stringify(response.data.authorization_endpoint));
              localStorage.setItem("selfHostedOidcScopes", JSON.stringify(res.scopes));

              history.push("/oidclogin");
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
        setState({
          ...state,
          isLogInSelfHostedIncorrect: true,
          isLoginLoading: false,
        });
      });
  }
};

//this is for the console React useEffect hook that is run on page load
export const handleConsoleComponentUseEffect = (
  setState,
  queryCode,
  state,
  history
) => {
  const urlCode = queryCode.code;
  setState({
    ...state,
    currentModule: window.location.pathname.split("/")[2],
  });
  localStorage.setItem(
    "currentModule",
    JSON.stringify(window.location.pathname.split("/")[2])
  );
  localStorage.setItem(
    "connectToWeaviateURI",
    JSON.stringify(state.connectToWeaviateURI)
  );

  getUserToken(urlCode, state, history, setState);

  //it gets a new access_token from keycloak every 3 minutes
  const interval = setInterval(() => {
    checkTokens();
  }, 700000);

  //it logs out the user after a while because sometimes the token expires
  const logoutInterval = setInterval(() => {
    const authenticated = JSON.parse(
      localStorage.getItem("isWeaviateAuthenticated")
    );

    if (authenticated) {
      logOut(setState, state, history);
    }
  }, 900000);

  return () => clearInterval(interval, logoutInterval);
};

const getOIDCTokenURL = () => {
  return getOidcTokenURL()
}

const getOIDCInfoURL = () => {
  return getOidcInfoURL();
}
